export enum CreationMethod {
  EXTERNAL = 'EXTERNAL',
  ARTWORK_MIXER = 'ARTWORK_MIXER',
}
